import { controls, grouped } from "../controls";
const apb_file_records = {
  label: "Apb File Records",
  pageLabel: "Apb File Records", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: true } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Apb File" }),
    ...controls.oc({ tab: "filter", c: "APBFile", placeHolder: "Apb File Code", name: "APBFileRecord-apb_file-apb_file_code", fastpath: "apb_files" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "APBFileRecord-apb_file-apb_file_display" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "Data", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "data", width: "col-sm-4", maxlength: 200, isReadOnly: "edit" }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Apb File Records",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Data", accessor: "data", },
      { Header: "Account Number", accessor: "account_number", },
      { Header: "Return Code", accessor: "return_code", },
      { Header: "Internal Message", accessor: "internal_message", },
    ]
  }
};
export default apb_file_records;